module.exports = __webpack_public_path__ + "static/img/domore-about.b52afcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/domore-about.jpg
// module id = 722
// module chunks = 1